export default __webpack_public_path__ + "static/media/JosefinSans-Light.05518b75.ttf";